<template>
  <RedesignWebccSelectButton
    icon="site/search"
    :text="model?.label"
    :placeholder="$t(`${trPrefix}placeholders.where`)"
    class="w-full min-w-[14.75rem]"
    @click="handleOpen"
    @clear="handleClear"
  />

  <RedesignWebccDialog
    full-screen="md"
    :open="isOpen"
    safari-scroll-anchor-fix
    @close="handleClose"
  >
    <template #title>
      <h3>{{ $t(`${trPrefixSearch}destination.title`) }}</h3>
    </template>

    <template #default>
      <main
        ref="mainRef"
        class="flex flex-col relative mb-0 flex-1 bg-bgr w-full"
      >
        <HeadlessCombobox
          v-model="model"
          as="div"
          nullable
          class="relative w-full h-full flex flex-col"
          @update:model-value="handleUpdate"
        >
          <div class="bg-bgr pb-4 pt-4 px-4 sticky top-0 z-10">
            <RedesignSearchDestinationInput ref="searchInputRef" />
          </div>

          <div class="flex-1 overflow-y-auto">
            <RedesignSearchDestinationSuggestionsMobile
              :suggestions="suggestions"
              :is-open="isContextOpen"
              :query="query"
            />
          </div>
        </HeadlessCombobox>
      </main>
    </template>
  </RedesignWebccDialog>
</template>

<script setup lang="ts">
import type { ComboboxInput } from '@headlessui/vue'
import type { SuggestionOption } from '~/composables/useDestinationSearch'

const trPrefix = 'www.components.elements.SearchBox.'
const trPrefixSearch = 'www.search.'

const searchInputRef = shallowRef<{
  inputRef: InstanceType<typeof ComboboxInput>
}>()
const mainRef = shallowRef<HTMLElement>()

const [isOpen, toggle] = useToggle()

const model = defineModel<SuggestionOption | undefined>()

const context = provideSearchDestination(model)

function handleClearWithFocus() {
  context.handleClear()

  nextTick(() => {
    const inputEl = searchInputRef.value?.inputRef?.$el
    if (inputEl) {
      inputEl.value = ''
      inputEl.focus()
    }
  })
}

provide(DESTINATION_SEARCH_KEY, {
  ...context,
  handleClearWithFocus,
})

const { query, suggestions, isOpen: isContextOpen, handleClear } = context

function handleClose() {
  toggle(false)
}

function handleOpen() {
  toggle(true)

  nextTick(() => {
    const inputEl = searchInputRef.value?.inputRef?.$el
    if (inputEl) {
      inputEl.focus()
    }
  })
}

function handleUpdate(value: SuggestionOption | undefined) {
  if (value) handleClose()
}
</script>
